var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { mapCamelKeysToSnakeKeysRecursively } from '../utils/case-conversion';
import { noop } from '../utils';
export var createFireAnalyticsEventTypeFn = function (state) {
    return function (action, optionalEventParameters, eventType) {
        var _a;
        var _b = require('./iris'), getFireProperEventTypeFn = _b.getFireProperEventTypeFn, getUnifiedEventFn = _b.getUnifiedEventFn;
        /*
         * To comply with our original contract, we'll re-create the opts and the initParams
         * with the current state. These only include props that are used by our functions,
         * or are required by our typing.
         */
        var dummyFunction = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); };
        var recreatedLinkInitOpts = {
            uniqueUserId: state.linkParams.uniqueUserId,
            version: state.linkParams.version,
            platform: state.linkParams.platform,
            sdk: state.linkParams.sdk,
            deviceMetadata: state.linkParams.deviceMetadata,
            featureFlags: state.linkParams.featureFlags,
            localStorageAvailable: state.linkParams.localStorageAvailable,
            linkToken: state.linkParams.linkToken,
            experiments: state.linkParams.experiments,
            dynamicConfigs: state.linkParams.dynamicConfigs,
            _demoModeEnabled: state.linkParams._demoModeEnabled,
            fireClientEvent: dummyFunction,
            postParentWindowMessage: dummyFunction,
        };
        var amount = state.linkParams.linkTokenPayload.amount
            ? {
                value: parseInt(state.linkParams.linkTokenPayload.amount, 10),
                unit: '$',
            }
            : undefined;
        var recreatedOpts = {
            selectedEmployer: state.providerEntity.selectedEmployer,
            loadedPlatform: (_a = state.linkApi.context) === null || _a === void 0 ? void 0 : _a.platform,
            linkParams: {
                amount: amount,
            },
            lastSource: state.segment.lastSource,
            currentSource: state.segment.currentSource,
            searchSessionId: state.segment.searchSessionId,
            loginAttemptId: state.linkApi.loginAttemptId,
            postLoginAttemptId: state.segment.postLoginAttemptId,
            manualInstructionsAttemptId: state.segment.manualInstructionsAttemptId,
            // The following params are only to comply with the interface
            linkToken: state.linkParams.linkToken,
            uniqueUserId: state.linkParams.uniqueUserId,
            version: state.linkParams.version,
            fireUnifiedEvent: dummyFunction,
            fireProperEventType: dummyFunction,
            fireTrackEvent: dummyFunction,
            isDemoMode: state.linkParams._demoModeEnabled,
            exit: noop,
        };
        var fireUnifiedEvent = getUnifiedEventFn(state.linkParams.linkTokenPayload, state.linkParams.modalSessionId, recreatedLinkInitOpts, null);
        if (eventType) {
            return fireUnifiedEvent(eventType, __assign({ entry_point: state.segment.lastSource, action: action, source: state.segment.currentSource }, mapCamelKeysToSnakeKeysRecursively(optionalEventParameters)));
        }
        return getFireProperEventTypeFn(fireUnifiedEvent)(action, recreatedOpts, optionalEventParameters);
    };
};
